import React from "react";

const FaceRecognition = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-face-recognition"
      data-name="icon-face-recognition"
      viewBox="0 0 24 24"
      width={_width}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path fill="none" d="M3 7V4a1 1 0 0 1 1-1h3" />
      <path fill="none" d="M17 3h3a1 1 0 0 1 1 1v3" />
      <path fill="none" d="M21 17v3a1 1 0 0 1-1 1h-3" />
      <path fill="none" d="M7 21H4a1 1 0 0 1-1-1v-3" />
      <circle fill="none" cx="12" cy="9.5" r="3" />
      <path fill="none" d="M6.5 18.5a5.5 5.5 0 0 1 11 0" />
      <path fill="none" d="M2 12h20" strokeWidth="1.5" strokeDasharray="2 2" />
    </svg>
  );
};

export default FaceRecognition;
